import React, { useCallback } from "react";

/**
 * Thin draggable divider used to resize the side panels on desktop.
 * side="left"  -> handle lives on the panel's right edge (drag right = wider)
 * side="right" -> handle lives on the panel's left edge  (drag left = wider)
 */
export default function ResizeHandle({ side, width, setWidth, min, max, onResizeStart, onResizeEnd }) {
  const onPointerDown = useCallback(
    (e) => {
      e.preventDefault();
      const startX = e.clientX;
      const startW = width;
      onResizeStart?.();

      const onMove = (ev) => {
        const dx = ev.clientX - startX;
        let next = side === "left" ? startW + dx : startW - dx;
        next = Math.max(min, Math.min(max, next));
        setWidth(next);
      };
      const onUp = () => {
        document.removeEventListener("pointermove", onMove);
        document.removeEventListener("pointerup", onUp);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
        onResizeEnd?.();
      };

      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
    },
    [side, width, setWidth, min, max, onResizeStart, onResizeEnd]
  );

  return (
    <div
      role="separator"
      aria-orientation="vertical"
      data-testid={`resize-${side}-handle`}
      onPointerDown={onPointerDown}
      onDoubleClick={() => setWidth(side === "left" ? 256 : 288)}
      className={`group absolute top-0 ${
        side === "left" ? "right-0" : "left-0"
      } z-30 h-full w-1.5 cursor-col-resize touch-none`}
      title="拖拽调整宽度 · 双击重置"
    >
      <span className="absolute inset-y-0 left-1/2 w-px -translate-x-1/2 bg-transparent group-hover:bg-[#002FA7] group-active:bg-[#002FA7] transition-colors" />
    </div>
  );
}
